import isArray from 'lodash/isArray';
import isNil from 'lodash/isNil';

export default {
  props: {
    active: Boolean,
  },
  data() {
    return {
      templateCharts: Array,
    };
  },
  watch: {
    active(active) {
      if (active) {
        this.loadData();
      }
    },
  },
  methods: {
    /**
     * 차트 클릭시 보여지는 모든 자원 차트에 Flot Line을 표현한다.
     * @param  {[type]} chart [description]
     * @param  {[type]} e     [description]
     * @return {[type]}       [description]
     * @author jda
     */
    onClickChart(chart, e) {
      if (isNil(chart.series[0])) {
        return;
      }
      const point = chart.series[0].searchPoint(e, true);
      this.$children[0].$children.forEach((component) => {
        const refs = component.$refs;
        const chartKeys = Object.keys(refs).filter((key) => key.toLowerCase().indexOf('chart'));
        if (point) {
          chartKeys.forEach((key) => {
            let plotLineChart = refs[key];
            if (isArray(refs[key])) {
              plotLineChart = plotLineChart[0];
            }
            if (plotLineChart.visible) {
              plotLineChart.setPlotLine(point.x);
              plotLineChart.setCustomTooltip('plotLine');
            }
          });
        }
      });
    },
    /**
     * 자원 차트별 subChart가 표현 될 경우 다른 자원의 main차트는 숨김처리한다.
     * @param  {[type]} selectedKey [description]
     * @param  {[type]} visible     [description]
     * @return {[type]}             [description]
     * @author jda
     */
    onClickAddButton(selectedKey, visible) {
      this.$children[0].$children.forEach((component) => {
        if (component.$vnode.key !== selectedKey) {
          component.mainChartVisible = visible;
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/performance/analysis.js